import { useAuth } from "zudoku/components";

export function WelcomePage() {
  const auth = useAuth();

  const username: string =
    (auth.user as any)?.name ||
    (auth.user as any)?.email ||
    (auth.user as any)?.profile?.email ||
    "";

  return (
    <div style={{ 
      maxWidth: '800px', 
      margin: '0 auto', 
      padding: '60px 20px',
      textAlign: 'center'
    }}>
      <h1 style={{ fontSize: '3rem', marginBottom: '1.5rem' }}>
        Welcome to SDP Developer Portal
      </h1>
      <p style={{ 
        fontSize: '1.25rem', 
        opacity: 0.7,
        marginBottom: '2rem',
        lineHeight: '1.6'
      }}>
        Access comprehensive API documentation, developer resources, and tools to integrate with our platform.
      </p>
      <div style={{
        padding: '2rem',
        backgroundColor: 'var(--zudoku-bg-secondary, rgba(0, 0, 0, 0.05))',
        borderRadius: '8px',
        marginBottom: '2rem',
        border: '1px solid var(--zudoku-border-color, rgba(0, 0, 0, 0.1))'
      }}>
        <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>
          Get Started
        </h2>
        <p style={{ fontSize: '1.1rem', marginBottom: '1.5rem' }}>
          {auth.isAuthenticated ? (
            <>Welcome{username ? <>, <strong>{username}</strong></> : null}! You have access to:</>
          ) : (
            <>Please <strong>log in</strong> using the button in the upper right corner to access:</>
          )}
        </p>
        <ul style={{ 
          textAlign: 'left', 
          display: 'inline-block',
          fontSize: '1rem',
          lineHeight: '2',
          listStyle: 'disc',
          padding: 0
        }}>
          <li>Complete API Documentation</li>
          <li>Developer Articles & Guides</li>
          <li>Subscription Management</li>
          <li>Tiered Content Access</li>
        </ul>
      </div>
    </div>
  );
}
